import { HostListener, Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable, Subscription } from 'rxjs';
import { PaginatedSearchOptions } from './paginated-search-options.model';

@Injectable({
  providedIn: 'root',
})
export class SearchPageOptionsService {
  private subscriptions: Subscription[] = [];

  private viewOptions$ = new BehaviorSubject<PaginatedSearchOptions>(
    new PaginatedSearchOptions()
  );

  constructor() {
    // this.subscriptions = [this.getIsMobileSub()];
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    const isMobile = window.innerWidth < 768;
    this.setViewMode(isMobile ? 'GRID' : 'TABLE');
  }

  captureEvent(eventName: string): Observable<Event> {
    return fromEvent(window, eventName);
  }

  onIsMobileChange(isMobile: boolean | null): void {
    if (isMobile === null) return;
    this.setViewMode(isMobile ? 'GRID' : 'TABLE');
  }

  // private getIsMobileSub(): Subscription {
  //   return this.utilService.isMobile$.subscribe((isMobile) => {
  //     this.onIsMobileChange(isMobile);
  //   });
  // }

  getViewOptions(): BehaviorSubject<PaginatedSearchOptions> {
    return this.viewOptions$;
  }

  setCurrentPage(value: number): void {
    let viewOption = this.getViewOptions();
    let viewOptions: PaginatedSearchOptions = {
      ...viewOption.getValue(),
      currentPage: value,
    };
    viewOption.next(viewOptions);
  }

  setPageSize(value: number): void {
    let viewOption = this.getViewOptions();
    let viewOptions: PaginatedSearchOptions = {
      ...viewOption.getValue(),
      pageSize: value,
    };
    viewOption.next(viewOptions);
  }

  setViewMode(value: 'TABLE' | 'GRID'): void {
    let viewOption = this.getViewOptions();
    let viewOptions: PaginatedSearchOptions = {
      ...viewOption.getValue(),
      viewMode: value,
    };
    viewOption.next(viewOptions);
  }
}
